import { render, staticRenderFns } from "./InsertProject.vue?vue&type=template&id=412391ec&scoped=true"
import script from "./InsertProject.vue?vue&type=script&lang=js"
export * from "./InsertProject.vue?vue&type=script&lang=js"
import style0 from "./InsertProject.vue?vue&type=style&index=0&id=412391ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412391ec",
  null
  
)

export default component.exports